export default function LabelStatus({title, value}:{title: string, value: string}) {
    return (
        <div className="flex flex-row">
            <h3 className="w-1/3 font-semibold">{title}</h3>
            <h3>:</h3>
            <h3 className="pl-3">{value}</h3>
        </div>
    )
}